// FLAGS: none
// The List / Calendar switch on "Spaces Schedules"; List comes first and is the default.
import { useTranslation } from "react-i18next";

export type HostSignupsViewMode = "list" | "calendar";

const MODES: Array<{ key: HostSignupsViewMode; labelKey: string }> = [
  { key: "list", labelKey: "HostSignups.View.List" },
  { key: "calendar", labelKey: "HostSignups.View.Calendar" },
];

interface HostSignupsViewSwitchProps {
  view: HostSignupsViewMode;
  onChange: (view: HostSignupsViewMode) => void;
}

const HostSignupsViewSwitch = ({
  view,
  onChange,
}: HostSignupsViewSwitchProps) => {
  const { t } = useTranslation();
  return (
    <div
      role="tablist"
      aria-label={t("HostSignups.View.Label")}
      className="inline-flex rounded-lg bg-slate-100 p-1"
    >
      {MODES.map((mode) => (
        <button
          key={mode.key}
          type="button"
          role="tab"
          aria-selected={view === mode.key}
          onClick={() => onChange(mode.key)}
          className={`rounded-md px-3 py-1 text-sm font-medium ${
            view === mode.key
              ? "bg-white text-indigo-800 shadow-sm"
              : "text-slate-700 hover:text-indigo-800"
          }`}
        >
          {t(mode.labelKey)}
        </button>
      ))}
    </div>
  );
};

export default HostSignupsViewSwitch;
